import { Routes } from "@angular/router";

export const notificationRoutes: Routes = [
  {
    path: 'notifications',
    loadComponent: () =>
      import('./pages/notification/notification.page').then((o) => o.NotificationPage),
  },
];
